import { themeChakra } from '@wow/themes';

// COLORES
const {
  colors: { secondary, success, error, tertiary, warning, info, danger, grey, neutral, primary, white, black, transparent, blackAlpha },
  shadows: { none, lg, xs, md, '2xl': dosXL, 'dark-lg': darkLg },
} = themeChakra;

export const colorsStyles = {
  ShadowNone: none,
  ShadowLg: lg,
  ShadowMd: md,
  Shadow2Xl: dosXL,
  ShadowDarkLg: darkLg,
  ShadowXs: xs,
  Black: black,
  White: white,
  Transparent: transparent,
  Info50: info[50],
  Info100: info[100],
  Info120: info[120],
  Grey40: grey[40],
  Grey50: grey[50],
  Grey60: grey[60],
  Grey70: grey[70],
  Grey100: grey[100],
  Grey120: grey[120],
  Neutral40: neutral[40],
  Neutral50: neutral[50],
  Neutral90: neutral[90],
  Warning100: warning[100],
  Primary50: primary[50],
  Primary60: primary[60],
  Primary90: primary[90],
  Primary100: primary[100],
  Primary110: primary[110],
  Primary130: primary[130],
  Secondary70: secondary[70],
  Secondary90: secondary[90],
  Secondary100: secondary[100],
  Secondary110: secondary[110],
  Tertiary100: tertiary[100],
  Tertiary110: tertiary[110],
  Success100: success[100],
  Error100: error[100],
  Error110: error[110],
  Danger100: danger[100],
  BlackAlpha400: blackAlpha[400],
};

export default { colorsStyles };
